import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import Box from '@mui/joy/Box'
import Typography from '@mui/joy/Typography'
import { CampaignAPI } from '../api/CampaignAPI'
import { CampaignAssetItem } from '../components/CampaignAssetItem'
import { AssetModal } from '../components/AssetModal'
import { useParams } from 'react-router-dom'
import { formatToLongDatetime } from '../utils'

export const CampaignDetails = () => {
    const [isOpen, setIsOpen] = useState(false)
    const [modalAsset, setModalAsset] = useState(null)
    const { campaignId } = useParams()

    const { data: campaign, isPending: campainPending } = useQuery({
        queryKey: ['campaign', campaignId],
        queryFn: () => CampaignAPI.get(campaignId),
    })

    const { data: assets, isPending: assetsPending } = useQuery({
        queryKey: ['campaign-assets', campaignId],
        queryFn: () => CampaignAPI.getAllAssets(campaignId),
    })

    const handleAssetClick = (asset) => {
        setModalAsset(asset)
        setIsOpen(true)
    }

    const handleModalClose = () => {
        setIsOpen(false)
    }

    const refreshPage = () => {
        // TODO: This is a quick way to get V1 working. In the future, consider mutating the existing table
        // client-side to represent the actions taken in the modal for better performance.
        console.log('asset changed')
        window.location.reload()
    }

    if (assetsPending || campainPending) return

    return (
        <Box sx={{ display: 'flex', flex: 1, p: 2, backgroundColor: 'white' }}>
            <Box sx={{ flex: 0.5 }} />
            <Box
                sx={{
                    flex: 5,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                }}
            >
                <Box sx={{ flex: 1 }}>
                    {
                        <>
                            <Typography level="h2">
                                {campaign?.data.title}
                            </Typography>
                            <Typography color="neutral" level="body-xs">
                                Created:{' '}
                                {formatToLongDatetime(
                                    campaign?.data.create_date
                                )}
                            </Typography>
                        </>
                    }
                </Box>
                <Typography level="h3">Content Plan</Typography>
                <Box sx={{ flex: 1, display: 'flex' }}>
                    <Box
                        sx={{
                            flex: 1,
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 2,
                        }}
                    >
                        {assets.data?.map((asset) => (
                            <CampaignAssetItem
                                key={asset.id}
                                asset={asset}
                                onSelect={handleAssetClick}
                                onDelete={console.log}
                            />
                        ))}
                    </Box>
                </Box>
            </Box>
            <Box sx={{ flex: 0.5 }} />
            {
                <AssetModal
                    isOpen={isOpen}
                    campaignId={campaign?.data.id}
                    asset={modalAsset}
                    onClose={handleModalClose}
                    onAssetChanged={refreshPage}
                />
            }
        </Box>
    )
}
